import { FC } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Paginator, SearchBar } from "../../../moleculas";
import usePaginator from "../../../moleculas/Paginator/usePaginator";
import CustomTable from "../../Table";
import useTable from "./useTable";

interface TopicDetailTableProps {
  headers: string[];
  rows: any[];
}

const TopicDetailTable: FC<TopicDetailTableProps> = ({ headers, rows }) => {
  const itemsOptions = [5, 10, 25, 50, 100];
  const {
    handleResult,
    onSelectChange,
    filter,
    results,
    itemsPerPage,
    setItemsPerPage,
  } = useTable(rows);
  const { currentPage, onPageChange, totalPages, itemsToShow } = usePaginator(
    itemsPerPage,
    results
  );
  const { t } = useTranslation("table");

  return (
    <div className="w-100 d-flex flex-column">
      <div className="w-100 d-flex flex-row mb-3 align-items-center">
        <div className="w-50 me-2">
          <SearchBar
            filter={filter}
            items={rows}
            handleResult={handleResult}
            inputText={t("search")}
          />
        </div>
        <div className="w-50 d-flex flex-row align-items-center">
          <div className="me-2">{t("filter")}</div>
          <Form.Select onChange={onSelectChange}>
            <option value={-1}>{t("none")}</option>
            {headers.map((header, index) => (
              <option key={index} value={index}>
                {header}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="ms-2 w-25 d-flex flex-row align-items-center">
          <div className="me-2">{t("pages")}</div>
          <Form.Select
            onChange={(e: any) => setItemsPerPage(Number(e.target.value))}
          >
            {itemsOptions.map((page, index) => (
              <option key={index} value={page}>
                {page}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
      <div className="mb-2">
        <Paginator
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      </div>
      <CustomTable headers={headers} rows={itemsToShow}></CustomTable>
      <div className="mt-2">
        <Paginator
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default TopicDetailTable;
